export default "__VITE_ASSET__ec901a36__"